// extracted by mini-css-extract-plugin
export default {"section5":"Section5_section5__+ir-h","card_container":"Section5_card_container__dIcXm","card":"Section5_card__4Jtan","button_container":"Section5_button_container__ZjcKd"};